import React from 'react'
import { List, useListRepository } from 'elentari'
import analistaMercadoriaRepository from './AnalistaMercadoriaRepository'

export default function AnalistaMercadorias(props) {
  const listOptions = {
    defaultOrder: 'data',
    fields: {
      id: {
        label: 'Id'
      },
      analista: {
        label: 'Analista',
        format: analista => analista.usuario
      }
    }
  }
  const listHook = useListRepository({
    repository: analistaMercadoriaRepository,
    path: 'analistas'
  })
  listHook.onClickEdit = null
  listHook.onClickNew = props.onClickNew
  listHook.deleteFItem = async item => {
    await analistaMercadoriaRepository.remove({ id: item.id })
    return listHook.fetchList()
  }
  return (
    <List
      {...props}
      {...listHook}
      hideDownloadIcon
      removeItem={null}
      undoRemove={null}
      onClickView={null}
      deleteFItem={listHook.deleteFItem}
      listOptions={listOptions}
    />
  )
}
